import {
  ITask,
  ITaskChecklistItem,
  TaskMaintenanceType,
} from 'src/interfaces/task';

export const isChecklistComplete = (
  task?: Pick<ITask, 'maintenanceType' | 'checklistItems'> | null
): boolean => {
  if (!task) return true;
  if (task.maintenanceType !== TaskMaintenanceType.PREVENTIVE) return true;

  const items = task.checklistItems ?? [];
  if (items.length === 0) return true;

  return items.every((item: ITaskChecklistItem) => item.completed);
};

export const checklistProgress = (
  items: ITaskChecklistItem[] | undefined
): { completed: number; total: number } => {
  const list = items ?? [];
  return {
    completed: list.filter((item) => item.completed).length,
    total: list.length,
  };
};
